import useMinWidth from '@/hooks/useMinWidth'

export function useIsMinWidthMd() {
  return useMinWidth('md')
}
